(function () {
  const root = document.querySelector('[data-qc-babatee]');
  if (!root) return;

  const product = JSON.parse(root.querySelector('[data-qc-product-json]').textContent);
  const moneyFormat = root.dataset.moneyFormat || '{{amount}} DH';
  const checkoutUrl = root.dataset.checkoutUrl || '/checkout';
  const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
  const cartClearUrl = root.dataset.cartClearUrl || '/cart/clear.js';
  const cartUpdateUrl = root.dataset.cartUpdateUrl || '/cart/update.js';

  const packs = Array.from(root.querySelectorAll('[data-qc-pack]'));
  const priceEls = root.querySelectorAll('[data-qc-price]');
  const compareEls = root.querySelectorAll('[data-qc-compare]');
  const mainImage = root.querySelector('[data-qc-main-image]');
  const thumbs = Array.from(root.querySelectorAll('[data-qc-thumb]'));
  const colorImagesEl = root.querySelector('[data-qc-color-images]');
  let colorImages = {};
  try {
    colorImages = JSON.parse((colorImagesEl && colorImagesEl.dataset.qcColorImages) || '{}');
  } catch (e) {
    colorImages = {};
  }
  const errorEl = root.querySelector('[data-qc-error]');
  const form = root.querySelector('[data-qc-form]');
  const isBabatee = root.dataset.qcHandle === 'babatee';
  const isPortebebe = root.dataset.qcHandle === 'portebebe' || root.classList.contains('qc-bt--portebebe');
  const submitBtn = root.querySelector('[data-qc-submit]');
  const hoursEl = root.querySelector('[data-qc-hours]');
  const minutesEl = root.querySelector('[data-qc-minutes]');
  const secondsEl = root.querySelector('[data-qc-seconds]');

  const colorMap = {
    black: '#111111',
    noir: '#111111',
    gray: '#8a8a8a',
    grey: '#8a8a8a',
    gris: '#8a8a8a',
    'army green': '#4b5d23',
    army: '#4b5d23',
    vert: '#4b5d23',
    burgandy: '#6b2d3c',
    burgundy: '#6b2d3c',
    bordeaux: '#6b2d3c',
    'navy blue': '#1b2a4a',
    navy: '#1b2a4a',
    bleu: '#1b2a4a',
    brown: '#5c4033',
    marron: '#5c4033',
    white: '#f4f4f4',
    blanc: '#f4f4f4',
  };

  function formatMoney(amount) {
    const value = (Number(amount) / 100).toFixed(0);
    return moneyFormat.replace('AMOUNT', value).replace('{{amount}}', value).replace('{{amount_no_decimals}}', value);
  }

  function optionNames() {
    return (product.options || []).map(function (option) {
      return typeof option === 'string' ? option : option.name;
    });
  }

  function sizeKey() {
    const names = optionNames();
    const index = names.findIndex(function (name) {
      return /size|taille/i.test(name || '');
    });
    return index === -1 ? 0 : index;
  }

  function colorKey() {
    const names = optionNames();
    const index = names.findIndex(function (name) {
      return /color|colour|couleur/i.test(name || '');
    });
    return index === -1 ? 1 : index;
  }

  function findVariant(size, color) {
    const sIndex = sizeKey();
    const cIndex = colorKey();
    return (product.variants || []).find(function (variant) {
      const options = variant.options || [variant.option1, variant.option2, variant.option3];
      const sizeOk = !size || options[sIndex] === size;
      const colorOk = !color || options[cIndex] === color;
      return sizeOk && colorOk;
    });
  }

  function selectedPack() {
    return (
      root.querySelector('[data-qc-pack].is-selected') ||
      root.querySelector(isBabatee || isPortebebe ? '[data-qc-pack][data-qty="1"]' : '[data-qc-pack][data-qty="2"]') ||
      packs[0]
    );
  }

  function currentQty() {
    return Number(selectedPack().dataset.qty || '1');
  }

  function currentPrice() {
    return Number(selectedPack().dataset.price || '0');
  }

  function currentCompare() {
    return Number(selectedPack().dataset.compare || '0');
  }

  function currentShipCents() {
    if (isBabatee && currentQty() === 1) return 3500;
    return 0;
  }

  function currentDue() {
    return currentPrice() + currentShipCents();
  }

  function updatePrices() {
    const price = formatMoney(currentPrice());
    const compare = formatMoney(currentCompare());
    const due = formatMoney(currentDue());
    priceEls.forEach(function (el) {
      el.textContent = price;
    });
    compareEls.forEach(function (el) {
      el.textContent = compare;
      el.hidden = currentCompare() <= currentPrice();
    });
    root.querySelectorAll('[data-qc-order-total]').forEach(function (el) {
      el.textContent = due;
    });
  }

  function setMainImage(src) {
    if (!src) return;
    const slide = slides.find(function (item) {
      return sameImage(item.dataset.src, src);
    });
    const resolved = (slide && slide.dataset.src) || src;
    if (mainImage) mainImage.src = resolved;
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', sameImage(thumb.dataset.src, resolved));
    });
    if (slide) {
      const index = slides.indexOf(slide);
      updateDots(index);
    }
    if ((isMobile() || isPortebebe) && sliderTrack && slide) {
      const index = Math.max(slides.indexOf(slide), 0);
      sliderTrack.scrollTo({ left: slideLeft(index), behavior: 'smooth' });
    }
  }

  function slideLeft(index) {
    if (!sliderTrack) return 0;
    if (!isPortebebe || !slides.length) return index * sliderTrack.clientWidth;
    const first = slides[0];
    const target = slides[index];
    if (!first || !target) return index * sliderTrack.clientWidth;
    return target.offsetLeft - first.offsetLeft;
  }

  function slideIndexFromScroll() {
    if (!sliderTrack) return 0;
    if (!isPortebebe || slides.length < 2) {
      return Math.round(sliderTrack.scrollLeft / Math.max(sliderTrack.clientWidth, 1));
    }
    let index = 0;
    let best = Infinity;
    slides.forEach(function (slide, i) {
      const dist = Math.abs(sliderTrack.scrollLeft - slideLeft(i));
      if (dist < best) {
        best = dist;
        index = i;
      }
    });
    return index;
  }

  const slider = root.querySelector('[data-qc-slider]');
  const sliderTrack = slider && slider.querySelector('.qc-bt__slider-track');
  const slides = Array.from(root.querySelectorAll('[data-qc-slide]'));
  const dotsWrap = root.querySelector('[data-qc-dots]');

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function imageFile(url) {
    if (!url) return '';
    return String(url)
      .split('?')[0]
      .split('/')
      .pop()
      .replace(/_\d+x\d*/g, '')
      .toLowerCase();
  }

  function sameImage(a, b) {
    if (!a || !b) return false;
    return a === b || imageFile(a) === imageFile(b);
  }

  function updateDots(index) {
    if (!dotsWrap) return;
    dotsWrap.querySelectorAll('.qc-bt__dot').forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });
    const src = slides[index] && slides[index].dataset.src;
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', sameImage(thumb.dataset.src, src));
    });
  }

  function scrollToSlide(src) {
    if (!isMobile() || !sliderTrack || !src) return;
    const slide = slides.find(function (item) {
      return sameImage(item.dataset.src, src);
    });
    if (slide) {
      const index = Math.max(slides.indexOf(slide), 0);
      sliderTrack.scrollTo({ left: index * sliderTrack.clientWidth, behavior: 'smooth' });
    }
  }

  if (dotsWrap && slides.length) {
    slides.forEach(function (slide, index) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'qc-bt__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Image ' + (index + 1));
      dot.addEventListener('click', function () {
        sliderTrack.scrollTo({ left: slideLeft(index), behavior: 'smooth' });
        if (mainImage) mainImage.src = slide.dataset.src;
      });
      dotsWrap.appendChild(dot);
    });
  }

  if (sliderTrack) {
    sliderTrack.style.direction = 'ltr';
    sliderTrack.scrollLeft = 0;
    sliderTrack.addEventListener('scroll', function () {
      const index = slideIndexFromScroll();
      updateDots(index);
      const slide = slides[index];
      if (slide && mainImage) mainImage.src = slide.dataset.src;
    });
  }

  function isBabateeAsset(src) {
    return /qc-babatee/i.test(String(src || ''));
  }

  function productMediaSrcs() {
    const media = product.media || [];
    const fromProduct = media
      .map(function (item) {
        return item.src || (item.preview_image && item.preview_image.src) || '';
      })
      .filter(Boolean);
    if (fromProduct.length) return fromProduct;
    return slides
      .map(function (slide) {
        return slide.dataset.src || '';
      })
      .filter(Boolean);
  }

  function portebebeImageForColor(color) {
    const raw = String(color || '')
      .toLowerCase()
      .replace(/ - .*/, '')
      .trim();
    const srcs = productMediaSrcs();
    const grey = srcs.find(function (src) {
      return /grey|gray/i.test(src);
    });
    const white = srcs.find(function (src) {
      return /56bce042|blanc|white/i.test(src);
    });
    if (/blanc|white/.test(raw)) return white || srcs[0] || '';
    return grey || srcs[0] || '';
  }

  function colorImage(color) {
    if (!color) return '';
    const raw = String(color).toLowerCase().replace(/ - .*/, '').trim();
    const aliases = {
      gray: ['gray', 'grey', 'gris'],
      grey: ['gray', 'grey', 'gris'],
      gris: ['gray', 'grey', 'gris'],
      navy: ['navy', 'navy blue', 'bleu', 'bleu marine'],
      'navy blue': ['navy', 'navy blue', 'bleu', 'bleu marine'],
      bleu: ['navy', 'navy blue', 'bleu', 'bleu marine'],
      'bleu marine': ['navy', 'navy blue', 'bleu', 'bleu marine'],
      burgundy: ['burgundy', 'burgandy', 'bordeaux'],
      burgandy: ['burgundy', 'burgandy', 'bordeaux'],
      bordeaux: ['burgundy', 'burgandy', 'bordeaux'],
      black: ['black', 'noir'],
      noir: ['black', 'noir'],
      blanc: ['blanc', 'white'],
      white: ['blanc', 'white'],
    };
    const keys = [raw].concat(aliases[raw] || []);
    let src = '';
    for (let i = 0; i < keys.length; i += 1) {
      if (colorImages[keys[i]]) {
        src = colorImages[keys[i]];
        break;
      }
    }
    if (!src) {
      const found = Object.keys(colorImages).find(function (key) {
        return key === raw || key.indexOf(raw) !== -1 || raw.indexOf(key) !== -1;
      });
      src = found ? colorImages[found] : '';
    }
    if (isPortebebe && (!src || isBabateeAsset(src))) {
      src = portebebeImageForColor(color);
    }
    return src;
  }

  function variantImage(variant) {
    if (!variant) return '';
    if (variant.featured_image && variant.featured_image.src && !(isPortebebe && isBabateeAsset(variant.featured_image.src))) {
      return variant.featured_image.src;
    }
    const options = variant.options || [variant.option1, variant.option2, variant.option3];
    const color = options[colorKey()];
    return colorImage(color);
  }

  function firstItemVariant() {
    const pack = selectedPack();
    const size = pack.querySelector('[data-qc-size="0"]');
    const color = pack.querySelector('[data-qc-color="0"]');
    return findVariant(size && size.value, color && color.value);
  }

  function updateItemImage(row) {
    if (!row) return;
    const img = row.querySelector('[data-qc-item-image]');
    const size = row.querySelector('[data-qc-size]');
    const color = row.querySelector('[data-qc-color]');
    const variant = findVariant(size && size.value, color && color.value);
    const src = variantImage(variant) || colorImage(color && color.value);
    if (img && src) img.src = src;
  }

  function selectPack(pack, options) {
    packs.forEach(function (item) {
      const on = item === pack;
      item.classList.toggle('is-selected', on);
      item.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    updatePrices();
    pack.querySelectorAll('.qc-bt__variant').forEach(updateItemImage);
    if (options && options.skipGallery) return;
    const variant = firstItemVariant();
    setMainImage(variantImage(variant));
  }

  packs.forEach(function (pack) {
    pack.addEventListener('click', function (event) {
      if (event.target.closest('select')) return;
      selectPack(pack);
    });
    pack.addEventListener('keydown', function (event) {
      if (event.target.closest('select')) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        selectPack(pack);
      }
    });
    pack.querySelectorAll('select').forEach(function (select) {
      select.addEventListener('change', function () {
        const row = select.closest('.qc-bt__variant');
        updateItemImage(row);
        if (pack.classList.contains('is-selected') && row) {
          const size = row.querySelector('[data-qc-size]');
          const color = row.querySelector('[data-qc-color]');
          const variant = findVariant(size && size.value, color && color.value);
          setMainImage(variantImage(variant) || colorImage(color && color.value));
        }
      });
    });
    pack.querySelectorAll('.qc-bt__variant').forEach(updateItemImage);
  });

  const startPack =
    root.querySelector('[data-qc-pack].is-selected') ||
    root.querySelector(isBabatee || isPortebebe ? '[data-qc-pack][data-qty="1"]' : '[data-qc-pack][data-qty="2"]') ||
    packs[0];
  if (startPack) selectPack(startPack, { skipGallery: true });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
      });
      setMainImage(thumb.dataset.src);
    });
  });

  root.querySelectorAll('[data-qc-swatch]').forEach(function (swatch) {
    const name = (swatch.dataset.qcSwatch || '').toLowerCase();
    const color = colorMap[name] || colorMap[name.replace(/ - .*/, '')] || '#888';
    swatch.style.background = color;
    swatch.addEventListener('click', function () {
      const select = swatch.closest('.qc-bt__field').querySelector('select');
      if (!select) return;
      select.value = swatch.dataset.qcSwatch;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      swatch.parentElement.querySelectorAll('[data-qc-swatch]').forEach(function (item) {
        item.classList.toggle('is-active', item === swatch);
      });
      const mapped = colorImage(swatch.dataset.qcSwatch);
      if (mapped) setMainImage(mapped);
    });
  });

  function tick() {
    const now = new Date();
    const end = new Date(now);
    end.setHours(23, 59, 59, 999);
    let diff = Math.max(0, end.getTime() - now.getTime());
    const hours = Math.floor(diff / 3600000);
    diff -= hours * 3600000;
    const minutes = Math.floor(diff / 60000);
    diff -= minutes * 60000;
    const seconds = Math.floor(diff / 1000);
    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
    if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  tick();
  setInterval(tick, 1000);
  updatePrices();

  function showError(message) {
    if (errorEl) errorEl.textContent = message || '';
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function normalizePhone(phone) {
    var value = String(phone || '').replace(/[\s.-]/g, '');
    if (value.indexOf('+212') === 0) value = '0' + value.slice(4);
    else if (value.indexOf('212') === 0 && value.length > 9) value = '0' + value.slice(3);
    return value.replace(/\D/g, '');
  }

  function findEasySellVm(name) {
    const rootVm = window.easysellApp;
    if (!rootVm) return null;
    const stack = [rootVm];
    while (stack.length) {
      const vm = stack.pop();
      const vmName = (vm.$options && (vm.$options.name || vm.$options._componentTag)) || '';
      if (vmName === name) return vm;
      (vm.$children || []).forEach(function (child) {
        stack.push(child);
      });
    }
    return null;
  }

  function fillVueInput(el, value) {
    if (!el) return;
    const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    setter.call(el, value);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function fillEasySellField(orderForm, key, value) {
    const lists = [orderForm.inputFields, orderForm.fields];
    if (orderForm.$store && orderForm.$store.state && orderForm.$store.state.form) {
      lists.push(orderForm.$store.state.form.fields);
    }
    lists.forEach(function (list) {
      if (!list) return;
      list.forEach(function (field) {
        if (field.value !== key) return;
        if (orderForm.$set) orderForm.$set(field, 'model', value);
        else field.model = value;
        field.hasError = false;
        if (typeof orderForm.onFieldChange === 'function') {
          try {
            orderForm.onFieldChange(field);
          } catch (e) {
            /* ignore */
          }
        }
      });
    });
    fillVueInput(document.getElementById('es-' + key), value);
  }

  function easySellHasOrder(orderForm) {
    const formState = orderForm && orderForm.$store && orderForm.$store.state && orderForm.$store.state.form;
    return Boolean(
      document.getElementById('es-thanks-modal') ||
        (formState && formState.order)
    );
  }

  async function waitForEasySellOrder(orderForm, timeoutMs) {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      if (easySellHasOrder(orderForm)) return true;
      await wait(200);
    }
    return easySellHasOrder(orderForm);
  }

  function easySellCart(orderForm) {
    return (
      orderForm &&
      orderForm.$store &&
      orderForm.$store.state &&
      orderForm.$store.state.cart &&
      orderForm.$store.state.cart.cart
    );
  }

  function applyPackPriceAndShipping(orderForm, packPriceCents, qty) {
    const store = orderForm.$store;
    if (!store || !store.state) return;
    const packPrice = Math.round(Number(packPriceCents) / 100);
    const cart = store.state.cart && store.state.cart.cart;
    if (cart && cart.items && cart.items.length && packPrice > 0) {
      const current = Number(cart.totalPrice || 0);
      const items = cart.items;
      const count = items.reduce(function (sum, item) {
        return sum + Number(item.quantity || 1);
      }, 0) || items.length;
      let remaining = packPrice;
      items.forEach(function (item, index) {
        const share =
          index === items.length - 1
            ? remaining
            : Math.round((packPrice * Number(item.quantity || 1)) / count);
        remaining -= share;
        item.line = share;
        item.linePrice = share;
        item.final_line_price = share;
        item.price = Math.round(share / Number(item.quantity || 1));
        item.final_price = item.price;
        item.discounted_price = item.price;
      });
      cart.totalPrice = packPrice;
      cart.original_total_price = current;
      cart.total_discount = Math.max(0, current - packPrice);
    }

    const option = isBabatee
      ? qty > 1
        ? {
            id: 'qc-babatee-free',
            name: 'Livraison incluse',
            price: 0,
            hasCondition: false,
          }
        : {
            id: 'qc-babatee-ship',
            name: 'Livraison',
            price: 35,
            hasCondition: false,
          }
      : isPortebebe
        ? qty > 1
          ? {
              id: 'qc-portebebe-free',
              name: 'Livraison incluse',
              price: 0,
              hasCondition: false,
            }
          : {
              id: '5ufbp2',
              name: 'Livraison',
              price: 30,
              hasCondition: false,
              limitProducts: 'whitelist',
              limitProductsType: 'products',
              products: ['11014074794311'],
            }
        : qty > 1
          ? {
              id: 'qc-babatee-free',
              name: 'Livraison gratuite',
              price: 0,
              hasCondition: false,
            }
          : {
              id: '5ufbp2',
              name: 'Livraison',
              price: 30,
              hasCondition: false,
              limitProducts: 'whitelist',
              limitProductsType: 'products',
              products: ['11014074794311'],
            };
    if (store.state.shipping) {
      store.state.shipping.options = [option];
      store.state.shipping.selectedOption = option;
    }
  }

  async function refreshEasySellCart(orderForm, app) {
    const store = orderForm.$store;
    if (store && typeof store.dispatch === 'function') {
      try {
        await store.dispatch('cart/fetchCart');
      } catch (e) {
        /* ignore */
      }
      try {
        await store.dispatch('shipping/setShippingOptions');
      } catch (e) {
        /* ignore */
      }
    } else if (app && typeof app.fetchCart === 'function') {
      try {
        await Promise.resolve(app.fetchCart());
      } catch (e) {
        /* ignore */
      }
    }
    for (let i = 0; i < 20; i += 1) {
      const cart = easySellCart(orderForm);
      if (cart && cart.itemCount > 0) return true;
      await wait(150);
    }
    return Boolean(easySellCart(orderForm) && easySellCart(orderForm).itemCount > 0);
  }

  async function submitEasySellInBackground(customer) {
    const app = findEasySellVm('App') || window.easysellApp;
    const orderForm = findEasySellVm('OrderForm');
    if (!app || !orderForm || typeof orderForm.validateAndSubmit !== 'function') {
      return false;
    }

    document.body.classList.add('qc-es-silent');

    if (typeof app.enablePopupForm === 'function') {
      try {
        app.enablePopupForm();
      } catch (e) {
        /* ignore */
      }
    } else if (typeof app.onStickyButtonClick === 'function') {
      try {
        app.onStickyButtonClick();
      } catch (e) {
        /* ignore */
      }
    }

    await wait(300);
    await refreshEasySellCart(orderForm, app);
    applyPackPriceAndShipping(orderForm, customer.packPrice, customer.qty);
    await wait(150);

    orderForm.selectedCountryCode = 'MA';
    if (orderForm.$store && orderForm.$store.state && orderForm.$store.state.form) {
      orderForm.$store.state.form.country = 'MA';
    }

    fillEasySellField(orderForm, 'first_name', customer.name);
    fillEasySellField(orderForm, 'phone', customer.phone);
    fillEasySellField(orderForm, 'address', customer.address);
    applyPackPriceAndShipping(orderForm, customer.packPrice, customer.qty);
    await wait(150);

    if (typeof orderForm.validate === 'function' && !orderForm.validate()) {
      if (typeof orderForm.closeEasySellPopup === 'function') orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
      return false;
    }

    const accepted = orderForm.validateAndSubmit();
    if (!accepted) {
      if (typeof orderForm.closeEasySellPopup === 'function') orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
      return false;
    }

    const placed = await waitForEasySellOrder(orderForm, 20000);
    if (!placed && typeof orderForm.closeEasySellPopup === 'function') {
      orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
    }
    return placed;
  }

  const isBabateeConfirm = false;
  const confirmRoot = root.querySelector('[data-qc-confirm]');
  const leadDays = Math.max(1, Number(root.dataset.qcLeadDays || 5));

  function startOfDay(date) {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return d;
  }

  function addDays(date, days) {
    const d = startOfDay(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  function sameDay(a, b) {
    return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  function formatDayMonth(date) {
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
  }

  function formatPlage(start, end) {
    if (!start || !end) return '';
    const y1 = start.getFullYear();
    const y2 = end.getFullYear();
    if (start.getMonth() === end.getMonth() && y1 === y2) {
      return start.getDate() + ' – ' + formatDayMonth(end) + ' ' + y2;
    }
    return formatDayMonth(start) + ' – ' + formatDayMonth(end) + ' ' + y2;
  }

  function minDeliveryStart() {
    return addDays(new Date(), leadDays);
  }

  function collectOrderDraft() {
    const name = form.elements.nom.value.trim();
    const phone = form.elements.telephone.value.trim();
    const city = form.elements.ville.value.trim();
    const address = form.elements.adresse.value.trim();
    if (!name || !phone || !city || !address) {
      showError('Merci de remplir nom, téléphone, ville et adresse.');
      return null;
    }
    if (!/^(?:\+?212|0)[5-8]\d{8}$/.test(phone.replace(/[\s.-]/g, ''))) {
      showError('Entrez un numéro marocain valide (06 / 07…).');
      return null;
    }
    const qty = currentQty();
    const pack = selectedPack();
    const items = [];
    const lines = [];
    for (let i = 0; i < qty; i += 1) {
      const sizeSelect = pack.querySelector('[data-qc-size="' + i + '"]') || pack.querySelector('[data-qc-size="0"]');
      const colorSelect = pack.querySelector('[data-qc-color="' + i + '"]') || pack.querySelector('[data-qc-color="0"]');
      const size = (sizeSelect && sizeSelect.value) || '';
      const color = (colorSelect && colorSelect.value) || '';
      const variant = findVariant(size, color);
      if (!variant || variant.available === false) {
        showError('Cette taille / couleur n’est pas disponible.');
        return null;
      }
      items.push({
        id: variant.id,
        quantity: 1,
        properties: {
          Pack: pack.dataset.name,
          Paiement: 'COD',
        },
      });
      lines.push((color ? color + ' · ' : '') + (size || '') + (qty > 1 ? ' (pièce ' + (i + 1) + ')' : ''));
    }
    return {
      name: name,
      phone: phone,
      city: city,
      address: address,
      qty: qty,
      pack: pack,
      packName: pack.dataset.name || 'Pack',
      packPrice: currentPrice(),
      items: items,
      lines: lines,
    };
  }

  function fillConfirmSummary(draft) {
    const box = confirmRoot.querySelector('[data-qc-confirm-summary]');
    if (!box) return;
    const ship = isBabatee
      ? draft.qty > 1
        ? 'Livraison incluse'
        : '+ 35 DH livraison'
      : draft.qty > 1
        ? 'Livraison gratuite'
        : '+ 30 DH livraison';
    box.innerHTML =
      '<p><strong>' +
      draft.packName +
      '</strong> · ' +
      formatMoney(draft.packPrice) +
      ' <span>(' +
      ship +
      ')</span></p><p>' +
      draft.lines.filter(Boolean).join('<br>') +
      '</p><p>' +
      draft.name +
      '<br>' +
      draft.phone +
      '<br>' +
      draft.address +
      ' — ' +
      draft.city +
      '</p><p>Paiement à la livraison</p>';
  }

  const confirmState = {
    view: startOfDay(minDeliveryStart()),
    start: null,
    end: null,
    slot: '',
    draft: null,
  };

  function showConfirmError(message) {
    const el = confirmRoot && confirmRoot.querySelector('[data-qc-confirm-error]');
    if (el) el.textContent = message || '';
  }

  function closeConfirmModal() {
    if (!confirmRoot) return;
    confirmRoot.hidden = true;
    document.body.classList.remove('qc-bt-confirm-open');
    showConfirmError('');
  }

  function renderCalendar() {
    const grid = confirmRoot.querySelector('[data-qc-cal]');
    const label = confirmRoot.querySelector('[data-qc-cal-label]');
    const hint = confirmRoot.querySelector('[data-qc-confirm-hint]');
    const plage = confirmRoot.querySelector('[data-qc-confirm-plage]');
    if (!grid) return;
    const minStart = minDeliveryStart();
    const year = confirmState.view.getFullYear();
    const month = confirmState.view.getMonth();
    if (label) {
      label.textContent = confirmState.view.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
    }
    if (hint) {
      hint.textContent =
        'Première plage possible : ' +
        formatPlage(minStart, addDays(minStart, 1)) +
        '. Impossible avant (délai de préparation).';
    }
    const first = new Date(year, month, 1);
    const startWeekday = (first.getDay() + 6) % 7;
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const weekdays = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
    let html = weekdays.map(function (d) {
      return '<span class="qc-bt-confirm__dow">' + d + '</span>';
    }).join('');
    for (let i = 0; i < startWeekday; i += 1) html += '<span></span>';
    for (let day = 1; day <= daysInMonth; day += 1) {
      const date = new Date(year, month, day);
      const disabled = date < minStart;
      const isStart = sameDay(date, confirmState.start);
      const isEnd = sameDay(date, confirmState.end);
      const inRange =
        confirmState.start &&
        confirmState.end &&
        date >= confirmState.start &&
        date <= confirmState.end;
      let cls = 'qc-bt-confirm__day';
      if (disabled) cls += ' is-disabled';
      if (inRange) cls += ' is-in';
      if (isStart) cls += ' is-start';
      if (isEnd) cls += ' is-end';
      html +=
        '<button type="button" class="' +
        cls +
        '" data-qc-day="' +
        date.getFullYear() +
        '-' +
        date.getMonth() +
        '-' +
        date.getDate() +
        '"' +
        (disabled ? ' disabled' : '') +
        '>' +
        day +
        '</button>';
    }
    grid.innerHTML = html;
    if (plage) {
      plage.textContent = confirmState.start
        ? 'Plage choisie : ' + formatPlage(confirmState.start, confirmState.end)
        : 'Choisissez le premier jour : la plage couvre ce jour et le lendemain.';
    }
  }

  function openConfirmModal(draft) {
    confirmState.draft = draft;
    confirmState.view = startOfDay(minDeliveryStart());
    confirmState.start = null;
    confirmState.end = null;
    confirmState.slot = '';
    fillConfirmSummary(draft);
    const flow = confirmRoot.querySelector('[data-qc-confirm-flow]');
    const thanks = confirmRoot.querySelector('[data-qc-confirm-thanks]');
    if (flow) flow.hidden = false;
    if (thanks) thanks.hidden = true;
    confirmRoot.querySelectorAll('[data-qc-slot]').forEach(function (btn) {
      btn.classList.remove('is-selected');
    });
    const available = confirmRoot.querySelector('[data-qc-commit-available]');
    const cash = confirmRoot.querySelector('[data-qc-commit-cash]');
    if (available) available.checked = false;
    if (cash) cash.checked = false;
    showConfirmError('');
    renderCalendar();
    confirmRoot.hidden = false;
    document.body.classList.add('qc-bt-confirm-open');
    const dialog = confirmRoot.querySelector('.qc-bt-confirm__dialog');
    if (dialog && dialog.focus) dialog.focus();
  }

  function setupConfirmModal() {
    if (!isBabateeConfirm || !confirmRoot) return;

    confirmRoot.querySelectorAll('[data-qc-confirm-close]').forEach(function (btn) {
      btn.addEventListener('click', closeConfirmModal);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !confirmRoot.hidden) closeConfirmModal();
    });
    const prev = confirmRoot.querySelector('[data-qc-cal-prev]');
    const next = confirmRoot.querySelector('[data-qc-cal-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        const min = minDeliveryStart();
        const prevMonth = new Date(confirmState.view.getFullYear(), confirmState.view.getMonth() - 1, 1);
        if (prevMonth.getFullYear() < min.getFullYear() || (prevMonth.getFullYear() === min.getFullYear() && prevMonth.getMonth() < min.getMonth())) {
          return;
        }
        confirmState.view = prevMonth;
        renderCalendar();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        confirmState.view = new Date(confirmState.view.getFullYear(), confirmState.view.getMonth() + 1, 1);
        renderCalendar();
      });
    }
    const grid = confirmRoot.querySelector('[data-qc-cal]');
    if (grid) {
      grid.addEventListener('click', function (event) {
        const btn = event.target.closest('[data-qc-day]');
        if (!btn || btn.disabled) return;
        const parts = btn.getAttribute('data-qc-day').split('-');
        const start = new Date(Number(parts[0]), Number(parts[1]), Number(parts[2]));
        confirmState.start = start;
        confirmState.end = addDays(start, 1);
        renderCalendar();
      });
    }
    confirmRoot.querySelectorAll('[data-qc-slot]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        confirmRoot.querySelectorAll('[data-qc-slot]').forEach(function (other) {
          other.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        confirmState.slot = btn.getAttribute('data-qc-slot') || '';
      });
    });

    const submitConfirm = confirmRoot.querySelector('[data-qc-confirm-submit]');
    if (submitConfirm) {
      submitConfirm.addEventListener('click', async function () {
        showConfirmError('');
        if (!confirmState.start || !confirmState.end) {
          showConfirmError('Choisissez une plage de 2 jours.');
          return;
        }
        if (!confirmState.slot) {
          showConfirmError('Choisissez un créneau horaire.');
          return;
        }
        const available = confirmRoot.querySelector('[data-qc-commit-available]');
        const cash = confirmRoot.querySelector('[data-qc-commit-cash]');
        if (!available || !available.checked || !cash || !cash.checked) {
          showConfirmError('Cochez les deux engagements pour confirmer.');
          return;
        }
        const draft = confirmState.draft;
        if (!draft) return;
        const plage = formatPlage(confirmState.start, confirmState.end);
        const delivery = {
          plage: plage,
          slot: confirmState.slot,
        };
        draft.items.forEach(function (item) {
          item.properties.Livraison = plage;
          item.properties.Creneau = confirmState.slot;
        });
        submitConfirm.disabled = true;
        submitConfirm.textContent = 'Envoi…';
        const placed = await placeOrder(draft, delivery);
        submitConfirm.disabled = false;
        submitConfirm.textContent = 'Je valide';
        if (!placed) {
          showConfirmError('Impossible d’envoyer la commande. Réessayez.');
          return;
        }
        const copy = confirmRoot.querySelector('[data-qc-confirm-thanks-copy]');
        if (copy) {
          copy.textContent =
            'Votre commande est bien passée. Livraison ' + plage + ', ' + confirmState.slot + '. Nous vous contactons pour confirmer.';
        }
        const flow = confirmRoot.querySelector('[data-qc-confirm-flow]');
        const thanks = confirmRoot.querySelector('[data-qc-confirm-thanks]');
        if (flow) flow.hidden = true;
        if (thanks) thanks.hidden = false;
      });
    }
  }

  async function placeOrder(draft, delivery) {
    const name = draft.name;
    const phone = draft.phone;
    const city = draft.city;
    const address = draft.address;
    const qty = draft.qty;
    const items = draft.items;
    const deliveryNote = delivery
      ? 'Livraison: ' + delivery.plage + ' · ' + delivery.slot
      : '';

    submitBtn.disabled = true;
    const original = submitBtn.innerHTML;
    submitBtn.textContent = 'جاري الإرسال…';

    try {
      await fetch(cartClearUrl, { method: 'POST', headers: { Accept: 'application/json' } });
      await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (response) {
        if (!response.ok) throw new Error('cart add failed');
        return response.json();
      });

      const attributes = {
        Nom: name,
        Téléphone: phone,
        Ville: city,
        Adresse: address,
        Paiement: 'Paiement à la livraison',
      };
      if (delivery) {
        attributes['Plage livraison'] = delivery.plage;
        attributes.Creneau = delivery.slot;
        attributes.Engagement = 'Disponible + cash à la livraison';
      }

      await fetch(cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          note:
            'Paiement à la livraison (COD) — BabaTee' + (deliveryNote ? ' — ' + deliveryNote : ''),
          attributes: attributes,
        }),
      });

      const discount = isBabatee ? '' : draft.pack.dataset.discount;
      if (discount) {
        await fetch('/discount/' + encodeURIComponent(discount), { credentials: 'same-origin' });
      }

      const placed = await submitEasySellInBackground({
        name: name,
        phone: normalizePhone(phone),
        address: address + ' — ' + city + (deliveryNote ? ' | ' + deliveryNote : ''),
        packPrice: draft.packPrice,
        qty: qty,
      });

      submitBtn.disabled = false;
      submitBtn.innerHTML = original;

      if (isBabateeConfirm) {
        if (!placed) document.body.classList.remove('qc-es-silent');
        return placed;
      }

      document.body.classList.remove('qc-es-silent');
      if (!placed) {
        showError('Impossible d’envoyer la commande. Réessayez.');
      }
      return placed;
    } catch (error) {
      document.body.classList.remove('qc-es-silent');
      showError('Impossible d’envoyer la commande. Réessayez.');
      submitBtn.disabled = false;
      submitBtn.innerHTML = original;
      return false;
    }
  }

  async function submitOrder(event) {
    event.preventDefault();
    showError('');
    const draft = collectOrderDraft();
    if (!draft) return;
    if (isBabateeConfirm && confirmRoot) {
      openConfirmModal(draft);
      return;
    }
    await placeOrder(draft, null);
  }

  form.addEventListener('submit', submitOrder);
  setupConfirmModal();

  function formIsComplete() {
    if (!form) return false;
    const name = (form.elements.nom && form.elements.nom.value.trim()) || '';
    const phone = (form.elements.telephone && form.elements.telephone.value.trim()) || '';
    const city = (form.elements.ville && form.elements.ville.value.trim()) || '';
    const address = (form.elements.adresse && form.elements.adresse.value.trim()) || '';
    return Boolean(name && phone && city && address);
  }

  function isInView(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.72 && rect.bottom > 80;
  }

  function goToForm() {
    const field = root.querySelector('#BabateeNom');
    const box = root.querySelector('.qc-bt__cod');
    const target = box || field;
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (field) {
      window.setTimeout(function () {
        field.focus({ preventScroll: true });
      }, 450);
    }
  }

  function goToBundle() {
    const bundle = root.querySelector('#qc-bt-bundle') || root.querySelector('[data-qc-bundle]');
    const packs = root.querySelector('[data-qc-bundle]');
    if (bundle) {
      bundle.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (packs) {
      packs.classList.add('is-target');
      window.setTimeout(function () {
        packs.classList.remove('is-target');
      }, 1300);
    }
  }

  root.querySelectorAll('[data-qc-scroll-order]').forEach(function (button) {
    button.addEventListener('click', function () {
      const packs = root.querySelector('[data-qc-bundle]');
      if (!isInView(packs)) {
        goToBundle();
        return;
      }
      if (!formIsComplete()) {
        goToForm();
        return;
      }
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  });

  root.querySelectorAll('[data-qc-scroll-product]').forEach(function (button) {
    button.addEventListener('click', function () {
      const photos = root.querySelector('#qc-bt-photos') || root.querySelector('.qc-bt__product');
      if (photos) photos.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
